<template>
    <div class="stepsdemo-content">
        <Card>
            <template v-slot:title>
                Riepilogo
            </template>
            <template v-slot:subtitle>
                I dati che hai inserito
            </template>
            <template v-slot:content>
                <div class="grid">
                    <div class="col-12 md:col-6" v-if="formData.name"><b>Nome:</b>{{formData.name}}</div> 
                    <div class="col-12 md:col-6"><b>Cellulare:</b>{{formData.mobile}}</div>
                    <div class="col-12 md:col-6"><b>Email:</b>{{formData.email}}</div>
                    <div class="col-12 md:col-6"><b>Note:</b>{{formData.note}}</div>
                    <div class="col-12 md:col-6"><b>Abilita selezione fattura bimestrale:</b>{{formData.abilita_scelta_bimestrale}}</div>
                    <div class="col-12 md:col-6"><b>Abilita visualizzazione generatore offerte:</b>{{formData.abilita_visualizzazione_generatore_offerte}}</div>
                    <div class="col-12 md:col-6"><b>Agente master:</b>{{formData.agente_master}}</div>
                    <div class="col-12 md:col-6" v-if="formData.agente_master === 'Si' && formData.mandato">
                        <b>Mandato:</b>{{ formData.mandato.title }} ({{ formData.mandato.fileName }})
                    </div>
                    <div class="col-12 md:col-6" v-else-if="formData.agente_master === 'Si'">
                        <b>Mandato:</b>non caricato
                    </div>
                    <div class="col-12 md:col-6" v-if="formData.agente_master === 'No'">
                        <b>Agenzia di appartenenza:</b>{{ parentAgentName }}
                    </div>
                </div>
            </template>
            <template v-slot:footer>
                <div class="grid justify-content-between">
                    <Button label="" @click="prevPage()" icon="pi pi-angle-left" iconPos="right" />
                    <i></i>
                    <Button  label="Salva" :disabled="isDisable" @click="complete()" icon="pi pi-check" iconPos="right" class="p-button-success"/>  
                </div>
            </template>
        </Card>
    </div>
</template>

<script>
import {ref, computed, getCurrentInstance, onMounted} from 'vue'
import Service from '@/services/ask-pratiche/pratiche-wizard'
import Card from 'primevue/card';
import Button from 'primevue/button';
import { useToast } from 'primevue/usetoast'

export default {
    components: {
        Card,
        Button,
    },
    props: {
        formData: Object
    },
    setup (props, {emit}) {
        const obj = ref([])
        const self = getCurrentInstance();
        self.$eventBus = self.appContext.config.globalProperties.$eventBus
        const service = new Service(self.$eventBus)
        const toast = useToast()
        const isDisable = ref(false);
        const agenti = ref([])

        onMounted(() => {
            if (props.formData?.agente_master === 'No' && props.formData?.id_parent) {
                service.getAgenti().then((res) => {
                    agenti.value = res.items || []
                })
            }
        })

        const parentAgentName = computed(() => {
            if (!props.formData?.id_parent) return '-'
            const agent = agenti.value.find(a => a.id == props.formData.id_parent)
            return agent?.name || props.formData.id_parent
        })

        const extractAgenteId = (res) => {
            if (!res || res.errore) return null
            if (res.id) return res.id
            if (typeof res === 'string') {
                const match = res.match(/"id"\s*:\s*(\d+)/)
                return match ? Number(match[1]) : null
            }
            if (typeof res.message === 'string') {
                const match = res.message.match(/"id"\s*:\s*(\d+)/)
                return match ? Number(match[1]) : null
            }
            return null
        }

        const prevPage = () => {
            emit('prev-page', {pageIndex: 1});
        }
        const complete = async () => {
            emit("activeLoader", true)
            isDisable.value = true 
            try {
                const res = await service.saveAgente(props.formData)
                const agenteId = extractAgenteId(res)

                if (!agenteId) {
                    toast.add({
                        severity: 'error',
                        summary: 'Errore',
                        detail: 'Creazione agente fallita',
                        life: 4000,
                    })
                    return
                }

                if (props.formData.agente_master === 'Si' && props.formData.mandato?.file?.length) {
                    const uploadRes = await service.uploadModuloAgente(props.formData.mandato, agenteId)
                    if (uploadRes?.errore || !uploadRes?.items?.success) {
                        toast.add({
                            severity: 'warn',
                            summary: 'Agente creato',
                            detail: uploadRes?.items?.msg || 'Upload mandato fallito',
                            life: 5000,
                        })
                        return
                    }
                }

                setTimeout(function() {
                    emit('complete');
                }, 1800);
            } finally {
                emit("activeLoader", false)
                isDisable.value = false
            }
        }      

        return {prevPage, complete, obj, isDisable, parentAgentName}
    },
    
}
</script>
